import React, { useEffect, useState } from 'react';
import { Modal, Space, Tooltip } from 'antd';
import { SpanButton } from 'component/button_components/button.style';
import TableComponent from 'component/table_component/antTable/table';
import { ReactComponent as EditIcon } from 'assets/images/SVG/icons/edit-icon.svg';
import { ReactComponent as DeleteIcon } from 'assets/images/SVG/icons/delete-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { AdminPageSizeWrap, AdminPageWrap, AdminTitleWrap } from 'pages/admin_page/style';
import { BackButton, StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { LeftArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import Swal from 'sweetalert2';
import { SweetSweetAlert } from 'component/sweetalert_components';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import {
  allowedHosts,
  deleteBranding,
  getAllowedHosts,
  getBrandings,
  getSingleBranding,
} from 'redux/slices/brandingSlice';
import UpdateBranding from 'component/modal_components/branding/update_branding';
import CreateBranding from 'component/modal_components/branding/create_branding';
import TableLoader from 'component/loader_component/tableLoader';
import { getDomainData } from 'redux/slices/domainSlice';
import { getThemes } from 'redux/slices/themeSlice';
import { AntToggleButton } from 'component/form_component/style';

export default function Brandings() {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [checkAction, setCheckAction] = useState(false);
  const [hosts, setHosts] = useState(false);
  const [recordData, setRecordData] = useState(null);
  const { data, loading, allowedHostStatus } = useSelector((state) => state.brandings);

  useEffect(() => {
    dispatch(getBrandings());
    dispatch(getThemes());
    dispatch(getAllowedHosts());
  }, []);
  useEffect(() => {
    setHosts(allowedHostStatus);
  }, [allowedHostStatus]);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'URL',
      dataIndex: 'url',
    },
    {
      title: 'Theme',
      dataIndex: 'themeName',
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      render: (_, record) => (
        <Space className='af-superadmin-branding-space-wrap'>
          <Tooltip title='Update' color='#597081' className='af-superadmin-branding-edit-tooltip'>
            <SpanButton className='af-superadmin-branding-edit-tooltip-button' onClick={() => handleEditClick(record)}>
              <EditIcon className='af-superadmin-branding-edit-tooltip-icon' />
            </SpanButton>
          </Tooltip>
          {record.id !== 1 && (
            <Tooltip title='Delete' color='#597081' className='af-superadmin-branding-delete-tooltip'>
              <SpanButton
                className='af-superadmin-branding-delete-tooltip-button'
                onClick={() => handleDeleteClick(record)}
              >
                <DeleteIcon className='af-superadmin-branding-delete-tooltip-icon' />
              </SpanButton>
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];
  const handleAllowHost = async (checked) => {
    const updateHosts = async () => {
      setEditLoader(true);
      try {
        await dispatch(allowedHosts({ enable: checked }));
      } catch (error) {
      } finally {
        setEditLoader(false);
        dispatch(getAllowedHosts());
      }
    };

    if (checked) {
      const result = await Swal.fire({
        icon: 'warning',
        title: `Once this is switched on you can't access AD Web from any other URLs than what are listed here`,
        showConfirmButton: true,
        confirmButtonColor: 'var(--bg-button-default-color)',
        width: '400px',
        heightAuto: false,
        showCancelButton: true,
        cancelButtonColor: 'green',
        confirmButtonText: 'OK, Update',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        customClass: {
          container: 'custom-swal-container',
          icon: 'custom-swal-icon',
          title: 'custom-swal-title',
        },
      });

      if (result.isConfirmed) {
        await updateHosts();
      }
    } else {
      await updateHosts();
    }
  };

  const handleCreate = async () => {
    await dispatch(getDomainData());
    setModal(true);
    setCheckAction(false);
  };

  const handleEditClick = async (record) => {
    setCheckAction(true);
    try {
      setEditLoader(true);
      await dispatch(getDomainData());
      const getSingleValue = await dispatch(getSingleBranding(record.id));
      if (getSingleValue?.payload.status === 200) {
        setModal(true);
        setRecordData(getSingleValue.payload.data);
      }
    } catch (err) {
      return err;
    } finally {
      setEditLoader(false);
    }
  };

  const handleDeleteClick = async (record) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Are you sure you want to delete?',
      showConfirmButton: true,
      confirmButtonColor: 'var(--bg-button-default-color)',
      width: '400px',
      heightAuto: false,
      showCancelButton: true,
      cancelButtonColor: 'green',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        container: 'custom-swal-container',
        icon: 'custom-swal-icon',
        title: 'custom-swal-title',
      },
    });

    if (result.isConfirmed) {
      try {
        const sweetAlert = await dispatch(deleteBranding(record.id));
        if (sweetAlert.payload && sweetAlert.payload.status === 200) {
          SweetSweetAlert({ sweetData: sweetAlert.payload.data.message, icon: 'success', buttonColor: 'green' });
          const { hostname, port } = window.location;
          const currentDomain = `${hostname}${port ? `:${port}` : ''}`;
          if (currentDomain === record.url) {
            window.location.reload(true);
          } else {
            dispatch(getBrandings());
          }
        } else {
          SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        }
      } catch (error) {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    }
  };

  return (
    <AdminPageWrap className='af-superadmin-branding-wrap'>
      <AdminPageSizeWrap className='af-superadmin-branding-content'>
        <BackButton className='af-superadmin-branding-backbutton' to='/'>
          <LeftArrowIcon className='af-superadmin-branding-leftarrow' /> Back
        </BackButton>
        <AdminTitleWrap className='af-superadmin-branding-title-wrap'>
          <h2 className='af-superadmin-branding-title-head'>Brandings</h2>
          <div className='af-superadmin-branding-title-button-wrap'>
            <div className='af-superadmin-branding-toggle-wrap'>
              <h3 className='af-superadmin-branding-toggle-label'>Only these hosts can access:</h3>
              <AntToggleButton
                checked={hosts}
                onChange={handleAllowHost}
                className='af-superadmin-branding-toggle-button'
              />
            </div>
            <StyledButton type='primary' onClick={handleCreate} className='af-superadmin-branding-title-button'>
              Add Branding
            </StyledButton>
          </div>
        </AdminTitleWrap>
        <div className='af-superadmin-branding-table-wrap'>
          <TableComponent
            columns={columns}
            data={data}
            loading={{
              spinning: loading,
              indicator: <TableLoader />,
            }}
          />
        </div>
      </AdminPageSizeWrap>
      {editLoader && <ModalOpenLoader />}
      {modal && (
        <Modal
          className='af-superadmin-branding-modal'
          open={modal}
          maskClosable={false}
          footer={[null]}
          onCancel={() => setModal(false)}
          centered
          width={600}
        >
          {checkAction ? (
            <UpdateBranding setModal={setModal} recordData={recordData} />
          ) : (
            <CreateBranding setModal={setModal} />
          )}
        </Modal>
      )}
    </AdminPageWrap>
  );
}
